import { render, staticRenderFns } from "./SelectPatientTable.vue?vue&type=template&id=50f669e6&"
import script from "./SelectPatientTable.vue?vue&type=script&lang=js&"
export * from "./SelectPatientTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports